import {
    BarController,
    BarElement,
    CategoryScale,
    Chart,
    Legend,
    LinearScale,
    LineController,
    Tooltip,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(
    BarElement,
    BarController,
    LineController,
    CategoryScale,
    LinearScale,
    Tooltip,
    ChartDataLabels,
    Legend
);

$ = jQuery;

class MoneyFlowSections {
    constructor() {
        this.init();
    }

    init() {
        $(document).on('ready', function () {
            loadBalanceChart();
        });

        var $contentContainer = $('#content-container'),
            $tableEl = $('[data-money-flow-table]'),
            $chartEl = $('[data-money-flow-chart]'),
            $form = $('.money-flow__options'),
            $loader = $('.js-ajax-loader');

        $('.money-flow__select').on('select2:select', function (e) {
            var data = $form.serialize();
            get_posts(data);
        });

        const chartWrapper = $('#balance_chart').closest('.stock-flow__chart');
        let axis = $('#balance_chart').attr('data-axis');
        let show_axes = $('#balance_chart').attr('data-display-axes');

        if (axis) axis = JSON.parse(axis);

        function get_posts(data) {
            $.ajax({
                type: 'POST',
                url: ajax.url,
                data: data,
                beforeSend: function (response) {
                    $loader.addClass('-active');
                },
                success: function (response) {
                    const responseParsed = JSON.parse(response);
                    const { table_html, chart_html } = responseParsed;

                    $tableEl.html(table_html).hide().fadeIn();
                    $chartEl.html(chart_html).hide().fadeIn();
                    loadBalanceChart();

                    setTimeout(function () {
                        $loader.removeClass('-active');
                    }, 1500);
                },
            });
        }

        function loadBalanceChart() {
            var $chartAnalysts = $('#balance_chart'),
                stepSize = $chartAnalysts.data('step-size'),
                stepSizeY1 = $chartAnalysts.data('step-size-y1'),
                data_set = $chartAnalysts.data('data-slice'),
                headings = $chartAnalysts.data('headings'),
                $labels = $chartAnalysts.data('labels') + '',
                max_y1 = $chartAnalysts.data('max-y1'),
                max_y2 = $chartAnalysts.data('max-y2'),
                colors = [
                    '#EBB700',
                    '#275794',
                    '#D9D9D9',
                    '#98BE6B',
                    '#747678',
                    '#1C2943',
                ];

            var display_axes = false;

            if (axis) {
                display_axes = true;
            }

            if (!show_axes) display_axes = false;

            var obj = [];

            function getDataset(index, data) {
                if (axis) {
                    return {
                        label: headings[index],
                        data: data,
                        backgroundColor: colors[index],
                        yAxisID: axis[index],
                    };
                } else {
                    return {
                        label: headings[index],
                        data: data,
                        backgroundColor: colors[index],
                    };
                }
            }

            if (data_set) {
                data_set.forEach(function (item, key) {
                    obj.push(getDataset(key, item));
                });
            }
            if ($labels) {
                var $split_labels = $labels.split(',');
            }

            if (data_set) {
                const htmlLegendPlugin = {
                    id: 'htmlLegend',
                    afterUpdate(chart, args, options) {
                        const items =
                            chart.options.plugins.legend.labels.generateLabels(
                                chart
                            );

                        var pointers =
                            document.querySelectorAll('.legend-pointer');

                        pointers.forEach(e => {
                            e.remove();
                        });

                        items.forEach((item, index) => {
                            const block = document.createElement('p');
                            block.classList.add('legend-pointer');
                            block.style.cursor = 'pointer';

                            block.onclick = () => {
                                chart.setDatasetVisibility(
                                    item.datasetIndex,
                                    !chart.isDatasetVisible(item.datasetIndex)
                                );

                                const legend = document.querySelector(
                                    '.legend-container-0'
                                );
                                const legend_2 = document.querySelector(
                                    '.legend-container-1'
                                );
                                const legend_3 = document.querySelector(
                                    '.legend-container-2'
                                );
                                const legend_4 = document.querySelector(
                                    '.legend-container-3'
                                );
                                const legend_5 = document.querySelector(
                                    '.legend-container-4'
                                );
                                const legend_6 = document.querySelector(
                                    '.legend-container-5'
                                );

                                legend.firstChild.remove();
                                legend_2.firstChild.remove();
                                legend_3.firstChild.remove();
                                legend_4.firstChild.remove();
                                if (legend_5) {
                                    legend_5.firstChild.remove();
                                }
                                if (legend_6) {
                                    legend_6.firstChild.remove();
                                }
                                chart.update();
                                if ($chartEl.length > 0)
                                    $chartEl[0].scrollIntoView();
                            };

                            const boxSpan = document.createElement('span');
                            boxSpan.style.background = item.fillStyle;
                            boxSpan.style.borderColor = item.strokeStyle;
                            boxSpan.style.borderWidth = item.lineWidth + 'px';
                            boxSpan.style.display = 'inline-block';
                            boxSpan.style.height = '28px';
                            boxSpan.style.marginRight = '10px';
                            boxSpan.style.width = '28px';

                            block.appendChild(boxSpan);

                            const el = document.querySelector(
                                '.legend-container-' + index
                            );
                            if (el) {
                                el.appendChild(block);
                            }
                        });
                    },
                };

                const getOrCreateTooltip = chart => {
                    let tooltipEl =
                        chart.canvas.parentNode.querySelector('div');

                    if (!tooltipEl) {
                        tooltipEl = document.createElement('div');
                        tooltipEl.classList.add('chart-tooltip');

                        const table = document.createElement('table');
                        table.classList.add('chart-table');

                        tooltipEl.appendChild(table);
                        chart.canvas.parentNode.appendChild(tooltipEl);
                    }

                    return tooltipEl;
                };

                const externalTooltipHandler = context => {
                    // Tooltip Element
                    const { chart, tooltip } = context;
                    const tooltipEl = getOrCreateTooltip(chart);

                    // Hide if no tooltip
                    if (tooltip.opacity === 0) {
                        tooltipEl.style.opacity = 0;
                        return;
                    }

                    // Set Text
                    if (tooltip.body) {
                        const titleLines = tooltip.title || [];
                        const bodyLines = tooltip.body.map(b => b.lines);

                        const tableHead = document.createElement('thead');

                        titleLines.forEach(title => {
                            const tr = document.createElement('tr');
                            tr.style.borderWidth = 0;

                            const th = document.createElement('th');
                            th.style.borderWidth = 0;
                            const text = document.createTextNode(title);

                            th.appendChild(text);
                            tr.appendChild(th);
                            tableHead.appendChild(tr);
                        });

                        const tableBody = document.createElement('tbody');
                        bodyLines.forEach((body, i) => {
                            const colors = tooltip.labelColors[i];

                            const span = document.createElement('span');
                            span.style.background = colors.backgroundColor;
                            span.style.borderColor = colors.borderColor;
                            span.style.borderWidth = '2px';
                            span.style.marginRight = '10px';
                            span.style.height = '10px';
                            span.style.width = '10px';
                            span.style.display = 'inline-block';

                            const tr = document.createElement('tr');
                            tr.style.backgroundColor = 'inherit';
                            tr.style.borderWidth = 0;

                            const td = document.createElement('td');
                            td.style.borderWidth = 0;

                            const text = document.createTextNode(body);

                            td.appendChild(span);
                            td.appendChild(text);
                            tr.appendChild(td);
                            tableBody.appendChild(tr);
                        });

                        const tableRoot = tooltipEl.querySelector('table');

                        // Remove old children
                        while (tableRoot.firstChild) {
                            tableRoot.firstChild.remove();
                        }

                        // Add new children
                        tableRoot.appendChild(tableHead);
                        tableRoot.appendChild(tableBody);
                    }

                    const { offsetLeft: positionX, offsetTop: positionY } =
                        chart.canvas;

                    const chartWrapperEl = chartWrapper.get(0);
                    const chartWrapperRect = chartWrapperEl.getBoundingClientRect();

                    const tooltipPosX = positionX + tooltip.caretX;
                    const tooltipPosY = positionY + tooltip.caretY;
                    const scrollOffset = (tooltipPosX - chartWrapperEl.scrollLeft);

                    // Display, position, and set styles for font
                    tooltipEl.style.opacity = 1;
                    tooltipEl.style.left = positionX  + tooltip.caretX + 'px';
                    tooltipEl.style.top = positionY + tooltip.caretY + 'px';
                    tooltipEl.style.font = tooltip.options.bodyFont.string;
                    tooltipEl.style.padding =
                        tooltip.options.padding +
                        'px ' +
                        tooltip.options.padding +
                        'px';
                };

                const myChart = new Chart($chartAnalysts, {
                    type: 'bar',
                    data: {
                        labels: $split_labels,
                        datasets: obj,
                    },
                    options: {
                        responsive: true,
                        layout: {
                            padding: {
                                top: 100,
                                right: !display_axes ? 64 : 0,
                            },
                        },
                        maintainAspectRatio: function () {
                            if (window.innerWidth < 992) {
                                return false;
                            } else {
                                return true;
                            }
                        },
                        scales: {
                            y1: {
                                beginAtZero: true,
                                // position: "left",
                                ticks: {
                                    callback: function (value) {
                                        if (value == 0) {
                                            return 0;
                                        } else {
                                            return value + ' M';
                                        }
                                    },
                                    grid: {
                                        display: true,
                                    },
                                    stepSize: stepSizeY1,
                                    padding: 16
                                },
                                // max: max_y1,
                            },
                            y2: {
                                beginAtZero: true,
                                display: display_axes,
                                position: 'right',
                                grid: {
                                    display: false,
                                },
                                max: max_y2,
                                ticks: {
                                    callback: function (value) {
                                        if (value == 0) {
                                            return 0;
                                        } else {
                                            return value + ' %';
                                        }
                                    },
                                    stepSize: 2,
                                    padding: 16,
                                },
                            },
                            x: {
                                grid: {
                                    display: false,
                                },
                            },
                        },
                        barPercentage: 0.8,
                        elements: {},
                        borderColor: 'rgba(12,41,15,0.3',
                        plugins: {
                            datalabels: {
                                anchor: 'end',
                                align: 'top',
                                // align: function(context) {
                                // var index = context.dataIndex;
                                // var value = context.dataset.data[index];
                                // return value < 150 ? 'top' : 'center';
                                // },
                                color: 'black',
                                // rotation: "-90",
                                // formatter: Math.round,
                                font: {
                                    size: 11,
                                },
                                padding: {
                                    bottom: 0,
                                },
                                offset: 0,
                            },
                            htmlLegend: {
                                containerID: 'legend-container',
                            },
                            legend: {
                                display: false,
                            },
                            tooltip: {
                                enabled: false,
                                position: 'nearest',
                                external: externalTooltipHandler,
                            },
                        },
                    },
                    plugins: [htmlLegendPlugin],
                });
            }
        }
    }
}

new MoneyFlowSections();
